import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-canvas text-foreground" data-id="element-0" data-mp="2rikmb2g0a59y">
      <MetaPixel data-id="element-1" data-mp="2mjpw3ffpleft" />
      <Hero data-id="element-2" data-mp="31aqd48uiugnk" />
      <StatsAndProof data-id="element-3" data-mp="31agput0v2nlk" />
      <PainPoints data-id="element-4" data-mp="31bs1tg4gn1nr" />
      <ProductOffer data-id="element-5" data-mp="31c9vq63nh3si" />
      <Pricing showAnchor data-id="element-6" data-mp="31ctf7r8y808n" />
      <ExtendedTestimonials data-id="element-7" data-mp="2wk9zanmsgt0o" />
      <GuaranteeAndFaq data-id="element-8" data-mp="2wiyvintcfl9k" />
      <CostSection data-id="element-9" data-mp="2wip5j08ate3v" />
      <Pricing description="Tu sistema completo para simplificar espacios, pertenencias, entorno digital, rutinas y compras." data-id="element-10" data-mp="2wi5lndz38fn7" />
      <FooterAndProofPopup data-id="element-11" data-mp="23vunsb2v8su3" />
    </main>;
}